import { SessionQuery } from '@/graphql/generated/session.generated';
import { isBrandPricingWorkspace, isSwonkieDevWorkspace } from '@/utils/users-path-filter';

type Workspace = SessionQuery['currentWorkspace'];

/**
 * On brand pricing every profile lives inside a brand, one per network, and the plan limit is the
 * number of brands: a profile connected outside a brand would slip past it. SwonkieDev workspaces
 * never reach the brands page, even in a brand pricing market.
 */
export const managesProfilesInBrands = (workspace: Workspace) =>
    isBrandPricingWorkspace(workspace) && !isSwonkieDevWorkspace(workspace);

/** Where the workspace manages its social profiles. */
export const getProfilesPath = (workspace: Workspace) =>
    managesProfilesInBrands(workspace) ? '/settings/workspace/brands' : '/settings/workspace/social-profile';
